export const PASSAGE_VIEW_PATH = '/passage';

export interface PassageViewUrlOptions {
  context?: string;
  nonRelativeUrl?: boolean;
  options?: string;
}

/**
 * Builds the URL for the app's bare passage-viewer route (rendered by the
 * `PassageView` page in the soulhx app), so `PassageLink` and the page
 * itself agree on the same query-param contract.
 *
 * `passage` and `context` are passed through untouched (not pre-formatted)
 * since `PassageView` resolves them itself via `convertRefToUsfm`.
 *
 * @param passage The passage reference
 * @param version Specific version of the Bible to use
 * @param optionals.context Context for the passage
 * @param optionals.nonRelativeUrl Builds fully-scoped URL instead of relative (i.e. `http://host:port/passage` instead of just `/passage`)
 * @returns A URL, relative to the app's origin, that opens the passage viewer
 */
export const getPassageViewUrl = (
  passage: string,
  version: string,
  { context = undefined, nonRelativeUrl = false, options = undefined }: PassageViewUrlOptions = {}
): string => {
  const params = new URLSearchParams({ ref: passage, version });
  if (context) {
    params.set('context', context);
  }
  if (options) {
    params.set('options', options);
  }

  return `${nonRelativeUrl ? window.location.origin : ''}${PASSAGE_VIEW_PATH}?${params.toString()}`;
};
